/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{createMotionProxy as o}from"./motion-proxy.js";import{createDomMotionConfig as t}from"./utils/create-config.js";import{gestureAnimations as r}from"../../motion/features/gestures.js";import{animations as m}from"../../motion/features/animations.js";import{drag as e}from"../../motion/features/drag.js";import{createDomVisualElement as i}from"./create-visual-element.js";import{layout as s}from"../../motion/features/layout.js";const f={...m,...r,...e,...s},a=o(((o,r)=>t(o,r,f,i)));export{a as motion};
//# sourceMappingURL=motion.js.map
